import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchMiniEntity } from '../../domain/entities/BranchMiniEntity'
import type { BranchAdminListedDtoAdmin } from '@/backend/market'

export class BranchMiniModel extends BranchMiniEntity {
  userId?: string 
  constructor(dataDto: BranchAdminListedDtoAdmin) {
    super()
    mapEntityProperties<BranchMiniModel>(this, dataDto)
  }
}
